/* Lychee Press homepage: slider + scroll reveal. Idempotent (sections may include it more than once). */
(function () {
  if (window.__lpHome) return;
  window.__lpHome = true;
  document.documentElement.classList.add('lp-js');

  function initSlider(root) {
    var track = root.querySelector('.lp-slider__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.lp-slide'));
    if (!track || slides.length < 2) { var nav = root.querySelectorAll('.lp-slider__btn, .lp-slider__dots'); nav.forEach && nav.forEach(function (n) { n.hidden = true; }); return; }
    var dotsWrap = root.querySelector('.lp-slider__dots');
    var prev = root.querySelector('.lp-slider__btn--prev');
    var next = root.querySelector('.lp-slider__btn--next');
    var index = 0, timer = null, paused = false;
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var dots = slides.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); });
      dotsWrap && dotsWrap.appendChild(b);
      return b;
    });

    function setActive(i) {
      index = i;
      dots.forEach(function (d, j) { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function go(i, user) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
      if (user) restart();
    }
    function restart() {
      if (!delay || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { if (!paused && document.visibilityState === 'visible') go(index + 1); }, delay);
    }

    prev && prev.addEventListener('click', function () { go(index - 1, true); });
    next && next.addEventListener('click', function () { go(index + 1, true); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    root.addEventListener('touchend', function () { paused = false; restart(); }, { passive: true });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      }, 80);
    }, { passive: true });

    setActive(0);
    restart();
  }

  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.lp-reveal:not(.is-in)'));
    if (!els.length) return;
    function show(e) { e.classList.add('is-in'); }
    // Fallback that never depends on IntersectionObserver: anything whose box is within the viewport gets revealed.
    var ticking = false;
    function sweep() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els = els.filter(function (e) {
        if (e.classList.contains('is-in')) return false;
        var r = e.getBoundingClientRect();
        if (r.top < vh * 0.94) { show(e); return false; }  // in view, or already scrolled past
        return true;
      });
      if (!els.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      els.forEach(function (e) { io.observe(e); });
    }
    sweep();
    setTimeout(sweep, 600);
    window.addEventListener('load', function () { setTimeout(sweep, 300); });
  }

  function initRow(root) {
    var row = root.querySelector('[data-lp-row-track]');
    if (!row) return;
    var step = function () { var c = row.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 320; };
    var prev = root.querySelector('.lp-ig__nav--prev'), next = root.querySelector('.lp-ig__nav--next');
    prev && prev.addEventListener('click', function () { row.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { row.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  }

  // Count-up animation for stat numbers (keeps prefix/suffix like "$", "+", "M", "years")
  function initCounters() {
    var els = document.querySelectorAll('.lp-stats__row strong:not([data-counter])');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function run(el) {
      // Re-runs every time the strip scrolls back into view; the final value is kept in data-final.
      if (el.getAttribute('data-running') === '1') return;
      el.setAttribute('data-counter', '1');
      var text = el.getAttribute('data-final') || el.textContent.trim();
      el.setAttribute('data-final', text);
      var m = text.match(/^([^0-9]*)([0-9][0-9,\.]*)(.*)$/);
      if (!m || reduce) return;
      var prefix = m[1], numStr = m[2], suffix = m[3];
      var target = parseFloat(numStr.replace(/,/g, ''));
      var decimals = (numStr.split('.')[1] || '').length;
      var useCommas = numStr.indexOf(',') !== -1;
      var dur = 1400, start = null;
      el.setAttribute('data-running', '1');
      function fmt(n) { var s = n.toFixed(decimals); if (useCommas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return prefix + s + suffix; }
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur); p = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * p);
        if (p < 1) requestAnimationFrame(step); else { el.textContent = text; el.removeAttribute('data-running'); }
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) run(en.target); });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  // Split the hero headline into words so they can tumble in one by one (keeps the <mark> intact)
  function initWords() {
    var h1 = document.querySelector('.lp-hero h1');
    if (!h1 || h1.getAttribute('data-words')) return;
    h1.setAttribute('data-words', '1');
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var s = document.createElement('span'); s.className = 'lp-word'; s.style.setProperty('--i', i++); s.textContent = part; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) { walk(n); }
      });
    }
    walk(h1);
    var mark = h1.querySelector('mark');
    if (mark) mark.style.setProperty('--n', i);
    h1.classList.remove('lp-reveal');
  }

  function init() {
    initWords();
    document.querySelectorAll('[data-lp-slider]').forEach(initSlider);
    initCounters();
    document.querySelectorAll('[data-lp-row]').forEach(initRow);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Shopify theme editor re-renders sections; re-init when it does.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lp-slider]').forEach(initSlider);
    e.target.querySelectorAll('[data-lp-row]').forEach(initRow);
    initCounters();
    initReveal();
  });
})();
